import React, { useRef, useState } from 'react';

export const DECK = [
  {
    label: 'Chat',
    title: 'Chat',
    copy: "Ask it to drill you on LNAT reasoning, break down a TMUA proof, or run a mock interview — it questions you back instead of just handing you an answer.",
    bullets: [
      'Runs real mock interviews, not scripts',
      'Adapts to the exam or interview you name',
      'Built for last-minute prep and long drilling sessions',
    ],
  },
  {
    label: 'Fluid',
    title: 'Fluid',
    copy: "A quiet, always-on study space that adapts to how you're actually working — reading past papers, drilling questions, or talking an answer through out loud.",
    bullets: [
      'Switches mode without switching tabs',
      'Tracks what you\'ve covered by exam or app',
      'No fixed curriculum to fight against',
    ],
  },
  {
    label: 'Studio',
    title: 'Studio',
    copy: "Build your own prep apps — a custom drill for your weakest UCAT section, a repeatable mock for your next interview, whatever you keep needing and can't find.",
    bullets: [
      'Build once, reuse before every session',
      'Shareable with your study group',
      'No code required to put one together',
    ],
  },
  {
    label: 'Apps',
    title: 'Apps',
    copy: 'A growing marketplace of exam and interview apps — built by IVORI, partner schools, and students — covering everything from LNAT to superday prep.',
    bullets: [
      'App-specific practice sets',
      'Community-built study tools',
      'One account, every surface',
    ],
  },
  {
    label: 'Cases',
    title: 'Cases',
    copy: 'A growing library of worked interview cases and past-paper questions — the same reasoning patterns IVORI-V1 was trained on, opened up for practice.',
    bullets: [
      'Consulting cases, bank interviews, admissions questions',
      'Each one shows the reasoning, not just the answer',
      'New cases added continuously',
    ],
  },
];

export default function EduProductDeck({ tabsRef, viewportRef }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartX = useRef(null);

  const goToDeck = (i) => {
    setActiveIndex((i + DECK.length) % DECK.length);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 40) {
      dx < 0 ? goToDeck(activeIndex + 1) : goToDeck(activeIndex - 1);
    }
    touchStartX.current = null;
  };

  return (
    <>
      <div className="edu-landing-deck-tabs edu-landing-fade-up" ref={tabsRef}>
        {DECK.map((d, i) => (
          <button
            type="button"
            key={d.label}
            className={`edu-landing-deck-tab ${i === activeIndex ? 'edu-landing-active' : ''}`}
            onClick={() => goToDeck(i)}
          >
            {d.label}
          </button>
        ))}
      </div>

      <div className="edu-landing-deck-viewport edu-landing-fade-up" ref={viewportRef}>
        <div
          className="edu-landing-deck-track"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {DECK.map((d, i) => (
            <div className="edu-landing-deck-card" key={d.label}>
              <div className="edu-landing-deck-card-copy">
                <div className="edu-landing-deck-card-num">
                  0{i + 1} / 0{DECK.length}
                </div>
                <h3>{d.title}</h3>
                <p>{d.copy}</p>
                <ul>
                  {d.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              </div>
              <div className="edu-landing-deck-visual">
                <div className="edu-landing-deck-visual-label">{d.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="edu-landing-deck-nav">
        <button
          type="button"
          className="edu-landing-deck-arrow"
          aria-label="Previous panel"
          onClick={() => goToDeck(activeIndex - 1)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button
          type="button"
          className="edu-landing-deck-arrow"
          aria-label="Next panel"
          onClick={() => goToDeck(activeIndex + 1)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </>
  );
}
